/**
 * A media query as an external store. Same `useSyncExternalStore` shape as the
 * filter store, and no resize listener — the browser tells us when the answer
 * changes.
 *
 * Used for the one layout decision that can't be pure CSS: the control panel
 * is a persistent sidebar at ≥1024px and a modal bottom sheet below it, and a
 * `<dialog>` can't be both.
 */

import { useMemo, useSyncExternalStore } from "react";

export function useMediaQuery(query: string): boolean {
  const [subscribe, getSnapshot] = useMemo(() => {
    const mql = typeof window === "undefined" ? null : window.matchMedia(query);
    return [
      (onChange: () => void) => {
        mql?.addEventListener("change", onChange);
        return () => mql?.removeEventListener("change", onChange);
      },
      () => mql?.matches ?? false,
    ] as const;
  }, [query]);

  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
